const PRODUCTION_APP_URL = "https://pm.beaccredited.com";

export function resolvePublicAppUrl(location, configuredUrl = process.env.REACT_APP_PUBLIC_APP_URL) {
    const configured = configuredUrl?.trim();
    if (configured) return configured.replace(/\/+$/, "");

    if (["localhost", "127.0.0.1", "[::1]"].includes(location.hostname)) {
        return location.origin;
    }

    return PRODUCTION_APP_URL;
}

export function buildPublicAppUrl(path = "") {
    return `${resolvePublicAppUrl(window.location)}${path}`;
}
